/* eslint-disable array-callback-return */
/* eslint-disable eqeqeq */
/* eslint-disable indent */
/* eslint-disable no-console */
/* eslint-disable no-unused-vars */
/* eslint-disable prefer-destructuring */
/* eslint-disable prettier/prettier */
/* eslint-disable react-hooks/rules-of-hooks */
/* eslint-disable @typescript-eslint/default-param-last */
/* eslint-disable @typescript-eslint/naming-convention */
/* eslint-disable @typescript-eslint/no-throw-literal */
/* eslint-disable @typescript-eslint/no-unused-vars */
/* eslint-disable @typescript-eslint/no-use-before-define */

import moment from 'moment';
import { BookEditionChapterModel } from '../../../../models/book/BookEditionChapterModel';
import { BookEditionModel } from '../../../../models/book/BookEditionModel';
import { ChapterTypes } from '../../../../pages/livro/enums/ChapterTypes';
import { http_client } from '../../../../util/http_client';
import { RequestUtil } from '../../../../util/RequestUtil';

export class BookRequests {
  static async getBookEditions(bookId: string) {
    const searchUrl = `${process.env.REACT_APP_CONTENT_BOOK_API}/books`;

    const result = await http_client.get<any>(`${searchUrl}/${bookId}`);

    if (result.status === 204) {
      return result.status;
    }

    const editions = await http_client.get<any>(
      `${searchUrl}/${bookId}/editions`
    );

    const editionsArray: any[] =
      editions && editions.data && editions.data.length ? editions.data : [];

    const data = [];
    if (result && result.data && result.data.num_id) {
      const bookSerie: any = result.data.book_serie
        ? result.data.book_serie
        : {};
      const tags: any = result.data.tags.length ? result.data.tags : [];
      const areaInterest: any = tags.find((t) =>
        t.id.includes('area-interest')
      );
      for (const edition of editionsArray) {
        const authors =
          edition.authors && edition.authors.length ? edition.authors : [];
        const coordinators =
          edition.coordinators && edition.coordinators.length
            ? edition.coordinators
            : [];
        const authorsString = [...authors, ...coordinators]
          .map((a) => a.title)
          .join(', ');
        data.push({
          id: result.data.num_id || 0,
          title: result.data.title || '',
          subtitle: edition.subtitle || '',
          image: `/books/cover/${bookId}/editions/${
            edition && edition.num_id ? edition.num_id : 0
          }.jpg`,
          img: `/books/cover/${bookId}/editions/${
            edition && edition.num_id ? edition.num_id : 0
          }.jpg`,
          description: edition.description || '',
          cdd: result.data.cdd || '',
          cdu: result.data.cdu || '',
          onlyView: edition.only_view || false,
          numberOfPages: edition.pages || 0,
          isbn: edition.isbn || '',
          year: moment(edition.publish_date).format('YYYY'),
          serie: bookSerie.title || '',
          author: authorsString || '',
          editionId: edition.num_id || 0,
          editionNumber: edition.number || 1,
          editionDate: '',
          areasInterest: areaInterest.title || '',
          yearExibition: '2022'
        });
      }
    }

    return data.map(
      (item: BookEditionModel) =>
        new BookEditionModel(
          item.id,
          item.title,
          item.subtitle,
          item.image,
          item.description,
          item.cdd,
          item.cdu,
          item.onlyView,
          item.numberOfPages,
          item.isbn,
          item.year,
          item.serie,
          item.author,
          item.editionId,
          item.editionNumber,
          item.areasInterest,
          result.status,
          item.yearExibition
        )
    );
  }

  static async getEditionChapters(bookId: string, editionId: string) {
    const searchUrl = `${process.env.REACT_APP_CONTENT_BOOK_API}/books/${bookId}`;

    const result = await http_client.get<ChapterDto[]>(
      `${searchUrl}/editions/${editionId}/chapters`
    );

    //console.log(result.data[12].items[3].digitalPage, '   <>    digitalPage');

    if (result.status === 204) {
      return result.status;
    }

    let data: any = [];
    if (result.data.length) {
      data = result.data.map((c: any) => ({
        id: c.num_id || 0,
        pdfName: c.pdf || '',
        Title: c.title || '',
        type: this.GetChapterTypeNumber(c.chapter_type || ''),
        subType: 1,
        sumaryID: 0,
        coordinatorWork: 'False',
        author: c && c.authors ? c.authors.map((a) => a.title).join(', ') : '',
        titlePresentation: '',
        title: c.title || '',
        items: c.items || []
      }));
    }

    return data
      .map(
        (item: any) =>
          new BookEditionChapterModel(
            item.id,
            item.title,
            item.author,
            this.GetChapterType(item.type),
            item.pdfName,
            item.titlePresentation,
            item.items || []
          )
      )
      .sort((a: BookEditionChapterModel, b: BookEditionChapterModel) =>
        a.subtitle === 'Pré textual' && b.subtitle !== 'Pré textual' ? 1 : -1
      )
      .sort((a: BookEditionChapterModel, b: BookEditionChapterModel) =>
        a.subtitle === 'Pós textual' && b.subtitle !== 'Pós textual' ? 1 : -1
      );
  }

  static async getChapterSignedUrl(
    bookId: string,
    editionId: string,
    chapterId: string
  ) {
    const searchUrl = `${process.env.REACT_APP_CONTENT_BOOK_API}/books/${bookId}`;

    const result = await http_client.get<ChapterDto[]>(
      `${searchUrl}/editions/${editionId}/chapters/${chapterId}/signed-url`
    );
    console.log(result.data, '  -  result.data');
    return result.data;
  }

  static async postLogChapter(chapterId: string) {
    return RequestUtil.createPostRequest(
      `api/book/postLogViewChapter/${chapterId}`
    )();
  }

  private static GetChapterType(chapterType: number) {
    switch (chapterType) {
      case ChapterTypes.PRE_TEXTUAL:
        return 'Pré textual';
      case ChapterTypes.CAPITULO:
        return 'Capítulos';
      case ChapterTypes.POS_TEXTUAL:
        return 'Pós textual';
    }
  }

  private static GetChapterTypeNumber(chapterType: string) {
    switch (chapterType) {
      case 'pre-textual':
        return ChapterTypes.PRE_TEXTUAL;
      case 'capitulo':
        return ChapterTypes.CAPITULO;
      case 'pos-textual':
        return ChapterTypes.POS_TEXTUAL;
    }
  }
}

type ChapterDto = {
  id: number;
  pdfName: string;
  title: string;
  type: number;
  subType: number;
  sumaryID: number;
  coordinatorWork: string;
  author: string;
  titlePresentation: string;
  items?: ChapterItemDto[];
};

type ChapterItemDto = {
  title: string;
  page: number;
  order: number;
  items?: ChapterItemDto[];
  createDate?: Date;
  alterDate?: Date;
  deleted?: boolean;
  draft?: boolean;
  digitalPage: number;
};
